import type { OnboardingStep } from "../types";

type HeadingsProps = {
  step: Pick<OnboardingStep, "title" | "description">;
  className?: string;
};

const Headings = ({ step, className }: HeadingsProps) => {
  return (
    <div className={`flex flex-col gap-[8px] ${className || ""}`}>
      <h2 className="text-[20px] font-medium leading-[110%] text-[#444]">
        {step.title}
      </h2>
      <p className="text-[14px] leading-[140%] text-[#666]">
        {step.description}
      </p>
    </div>
  );
};

export default Headings;
